import React, { useEffect } from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import LogoX from './../../assets/icons/gumla.png';
import Waiter from './../../assets/gif/blueCircle.gif';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
const JComponent= () => {
	const navigate=useNavigate();
	useEffect(()=>{
		if(localStorage.getItem("_lio")==null || localStorage.getItem("_lio")===""){
			navigate(URLPREFIX+"/login");
		}
	},[])
  return(
    <>
	<div className='container'>
		<nav className="navbar navbar-expand-lg navbar-light private">
		  <div className="container-fluid">
			<a className="navbar-brand" href="#">
				<img src={LogoX} className='logo-sm' />
			</a>
			<span>
				<span className='fs-5 fw-bolder'>Gram Sampati, Ramgarh</span>
				<br/>
				<center className='fs-7'>  Digital Asset Register</center>
			</span>
			<button className="navbar-toggler shadow rounded-circle px-3 py-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
			  <i className="bi bi-three-dots-vertical"></i>
			</button>
			<div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
			  <ul className="navbar-nav">
				<li className="nav-item">
				  <Link className="nav-link" aria-current="page" to={URLPREFIX+"/create/document"}>Create Assets</Link>
				</li>
				{/*<li className="nav-item">
				  <a className="nav-link" href={URLPREFIX+"/nfts"}>NFTs</a>
				</li>
				<li className="nav-item">
				  <Link className="nav-link" to={URLPREFIX+"/create/document"}>Create Document</Link>
				</li>
				<li className="nav-item dropdown">
				  <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
					Settings
				  </a>
				  <ul className="dropdown-menu">
					<li><Link className="dropdown-item" to={URLPREFIX+"/create/user"}>Create new user</Link></li>
					<li><a className="dropdown-item" href="#">Another action</a></li>
					<li><hr className="dropdown-divider"/></li>
					<li><a className="dropdown-item" href="#">Something else here</a></li>
				  </ul>
  				</li>*/}
				<li className="nav-item">
				  <div className="nav-link text-danger cursor-pointer" 
				  onClick={e=>{
					localStorage.setItem("_lio","");
					localStorage.removeItem("_lio");
					navigate(URLPREFIX+"/login");
				  }}
				  >Logout</div>
				</li>
				
			  </ul>
			</div>
		  </div>
		</nav>
	</div>
	</>
	);
};
export default JComponent;